export const RECIPIENT_FILTERS = {
    IsActive: { label: "", value: "" },
    IsTinRequested: { label: "", value: "" },
    IsW8request: "",
    IsW9Request: "",
    TinStartDate: "",
    TinEndDate: "",
}
export const W8W9_REQUESTS_PLAN_E = "PlanE";

export const W8W9_REQUESTS_PLANS = [
    { label: "25 Requests. ($7.00)", value: "PlanA", price: 7 },
    { label: "200 Requests. ($45.00)", value: "PlanB", price: 45 },
    { label: "1000 Requests. ($95.00)", value: "PlanC", price: 95 },
    { label: "5,000 Requests. ($175.00)", value: "PlanD", price: 175 },
    { label: "More than 5,000 (Contact us for pricing)", value: W8W9_REQUESTS_PLAN_E },
]

export const TIN_STATUS_OPTIONS = [{ label: "Blocked", value: true }, { label: "Processing", value: false }, { label: "Rejected", value: true }]

export const ACTIVE_INACTIVE_STATUS_OPTIONS = [{ label: "Active", value: true }, { label: "Inactive", value: false }]

export const W8_W9_STATUS_OPTIONS = [
    { label: "W8 Requested", value: "IsW8request", key: "W8Requested" },
    { label: "W9 Requested", value: "IsW9Request", key: "W9Requested" },
    { label: "W8 Completed", value: "W8Completed", key: "W8Completed" },
    { label: "W9 Completed", value: "W9Completed", key: "W9Completed" },
    { label: "None", value: "None" }
]

export const IS_TIN_REQUESTED_OPTIONS = [
    { label: "TIN Match Requested", value: true, key: "Requested" },
    { label: "TIN Match Not Requested", value: false, key: "NotRequested" }
]

export const RECIPIENT_LISTING_LOADING_STATES = {
    FETCHING_RECIPIENT_LIST_LOADING: "FETCHING_RECIPIENT_LIST_LOADING",
    FETCHING_RECIPIENT_LIST_READY: "FETCHING_RECIPIENT_LIST_READY",
    DELETE_RECIPIENT_LOADING: "DELETE_RECIPIENT_LOADING",
    DELETE_RECIPIENT_READY: "DELETE_RECIPIENT_READY",
    BULK_ADDRESS_MATCH_LOADING: "BULK_ADDRESS_MATCH_LOADING",
    BULK_ADDRESS_MATCH_READY: "BULK_ADDRESS_MATCH_READY",
    W8_W9_DOWNLOAD_PDF_LOADING: "W8_W9_DOWNLOAD_PDF_LOADING",
    W8_W9_DOWNLOAD_PDF_READY: "W8_W9_DOWNLOAD_PDF_READY",
    BULK_INACTIVATE_LOADING: "BULK_INACTIVATE_LOADING",
    BULK_INACTIVATE_READY: "BULK_INACTIVATE_READY",
    BULK_REACTIVATE_LOADING: "BULK_REACTIVATE_LOADING",
    BULK_REACTIVATE_READY: "BULK_REACTIVATE_READY",
    BLOCK_TIN_MATCH_LOADING: "BLOCK_TIN_MATCH_LOADING",
    BLOCK_TIN_MATCH_READY: "BLOCK_TIN_MATCH_READY",
    UNBLOCK_TIN_MATCH_LOADING: "UNBLOCK_TIN_MATCH_LOADING",
    UNBLOCK_TIN_MATCH_READY: "UNBLOCK_TIN_MATCH_LOADING",
    UPDATE_RECIPIENT_EMAIL_LOADING: "UPDATE_RECIPIENT_EMAIL_LOADING",
    UPDATE_RECIPIENT_EMAIL_READY: "UPDATE_RECIPIENT_EMAIL_READY",
}

export const RECIPIENT_LISTING_MESSAGE_MAP = {
    [RECIPIENT_LISTING_LOADING_STATES.FETCHING_RECIPIENT_LIST_LOADING]: "fetching recipients",
}

export const BLOCKED = "Blocked"

export const VIEW_TIN_CHECKBOX_MESSAGE = "If this checkbox is selected it will show the TINs of all recipients in the info grid below and if a PDF download is requested, recipient TINs will be unmasked there as well."

export const MISSING_RECIPIENT_DATA_TEXT = "Please select valid recipient"

export const FIELDS_TEXTS = {
    EMAIL_ID_TEXT: "emailid",
    LASTNAME_TEXT: "LastName",
    IDNUMBER_TEXT: "IdNumber"
}
export const TIN_STATUSES = {
    BLOCK_TIN_TEXT: "Request TIN Block",
    UN_BLOCK_TIN_TEXT: "Request TIN Unblock",
    TIN_REQUEST_TEXT: "Request TIN Match"
}